module.exports = __webpack_public_path__ + "img/4.208467b6.png";